<template lang="pug">
.resend-questionaire-modal
  b-modal(v-model="_modalShow" size="lg" no-close-on-backdrop no-close-on-esc @ok="send" @cancel="cancel")
    div(slot="modal-title")
      span {{ modalTitle }}

    .testmail-modal-body
      div.mb-2
        span 未回答の方にメッセージを再送し、回答の返信を促すことが出来ます。
        br
        span メッセージのタイトルと本文は編集できますが、その他の情報は変更することが出来ません。
      .register-body
        FormLabel(key-name="宛先" :value="target")
        FormInput(v-model="_messageTitle" name="remind-title" key-name="タイトル" type="text" placeholder="タイトル"
          :maxlength="100" :validation-rules="{ required: true, max: 100 }" :styles="{ width: '340px' }" required)
        FormTextarea(v-model="_messageText" name="remind-text" key-name="本文" placeholder="本文" :maxlength="1000" 
          :validation-rules="{ required: true, max: 1000 }" :styles="{ maxWidth: '720px', width: '720px', minHeight: '160px' }" required)

    .testmail-modal-footer(slot="modal-footer" slot-scope="{ ok, cancel }" style="width:100%;")
      ValidationAlert(v-model="showValidationAlert")
      .buttons.d-flex.justify-content-end
        button.btn.modal-ok-btn(type="button" @click="ok()") 送信
        button.btn.modal-cancel-btn(type="button" @click="cancel()") キャンセル
</template>

<script lang="ts">
import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { Validator } from "vee-validate";

import ValidationAlert from "@/pc/basics/ValidationAlertByValidator.vue";
import FormLabel from "@/pc/components/forms/FormLabel.vue";
import FormInput from "@/pc/components/forms/FormInput.vue";
import FormTextarea from "@/pc/components/forms/FormTextarea.vue";

/**
 * ### 再送信メッセージ送信確認モーダル
 */
@Component({
  components: {
    ValidationAlert,
    FormLabel,
    FormInput,
    FormTextarea
  }
})
export default class ResendInputModal extends Vue {
  // 親コンポーネントのバリデーターをInjectionする
  @Inject("$validator") $validator!: Validator;

  @Prop({ required: true })
  value!: boolean;

  @Prop({ required: true })
  modalTitle!: string;

  @Prop()
  target!: string;

  @Prop({ required: true })
  messageTitle!: string;

  @Prop({ required: true })
  messageText!: string;

  @Prop()
  showValidationAlert!: boolean;

  get _modalShow(): boolean {
    return this.value;
  }

  set _modalShow(newValue: boolean) {
    this.$emit("input", newValue);
    return;
  }

  get _messageTitle(): string {
    return this.messageTitle;
  }

  set _messageTitle(newValue: string) {
    this.$emit("update:messageTitle", newValue);
    return;
  }

  get _messageText(): string {
    return this.messageText;
  }

  set _messageText(newValue: string) {
    this.$emit("update:messageText", newValue);
    return;
  }

  get _showValidationAlert(): boolean {
    return this.showValidationAlert;
  }

  set _showValidationAlert(newValue: boolean) {
    this.$emit("update:showValidationAlert", newValue);
    return;
  }

  /**
   * ### 送信ボタン押下処理
   *
   * - モーダルを非表示にするか否かは親コンポーネントに移譲する
   */
  public send(modalEvent: any): void {
    this.$emit("update:showValidationAlert", false);
    modalEvent.preventDefault();
    this.$emit("ok");

    return;
  }

  public cancel(): void {
    this.$emit("update:showValidationAlert", false);
    return;
  }
}
</script>
